import { ReactNode } from 'react';

import Typography from '@components/atoms/Typography';

import classes from './StaticLayout.module.scss';

type Props = {
  children: ReactNode;
};

const StaticLayoutHeading = ({ children }: Props) => <div className={classes.heading}>{children}</div>;

const StaticLayoutHeader = ({ children }: Props) => (
  <Typography variant="h1" className={classes.header}>
    {children}
  </Typography>
);

const StaticLayoutDescription = ({ children }: Props) => (
  <Typography variant="body1" renderAs="div" className={classes.description}>
    {children}
  </Typography>
);

const StaticLayout = ({ children }: Props): JSX.Element => <div className={classes.wrapper}>{children}</div>;

StaticLayout.Heading = StaticLayoutHeading;
StaticLayout.Header = StaticLayoutHeader;
StaticLayout.Description = StaticLayoutDescription;

export default StaticLayout;
